import { atom } from "jotai";

import { Dimensions } from "src/components/DimensionedLayout/useRefDimensions.ts";
import { defaultPageSize } from "src/config/table-config.ts";

export const dimensionsAtom = atom<{ pageSize: number; dimensions?: Dimensions }>({
  pageSize: defaultPageSize,
  dimensions: undefined,
});
